import {TweenMax, Elastic} from 'gsap';

const duration = 1;

export default {
	show(target, cb){
		return TweenMax
			.from(target, duration, {
				opacity: 0,
				onComplete(){
					cb();
				},
				ease: Elastic.easeOut.config(0.25, 1),
			})
	},
	hide(target, cb){
		return TweenMax
			.to(target, duration, {
				opacity: 0,
				onComplete(){
					cb();
				},
				ease: Elastic.easeOut.config(0.25, 1),
			})
	},
	zoomOut(target, cb){
		return TweenMax
			.to(target, duration, {
				opacity: 0,
				scaleX: 2,
				scaleY: 2,
				onComplete(){
					cb();
				},
				ease: Elastic.easeOut.config(0.25, 1),
			})
	}
}


// WEBPACK FOOTER //
// ./src/animations/animations.js